import { TDocumentData } from "../models";

export function matchFileToField(dataId: string, fieldName: string): boolean {
  return dataId === fieldName || dataId.startsWith(fieldName + ":");
}

export function getFilesForField(
  fieldName: string,
  fileItems: TDocumentData[]
): TDocumentData[] {
  return fileItems.filter((item) => matchFileToField(item.dataId, fieldName));
}
